import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Register from "./Register";
import CreatePost from "./CreatePost";
import Statistics from "./Statistics";
import ViewProfile from "./ViewProfile";
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import PrivateRoute from "./PrivateRoute";
import Gamification from "./Gamification";
import FindFriend from "./FindFriend";
import UpcomingBday from "./UpcomingBday";
import LoginHistory from "./LoginHistory";
import HelpCenter from "./HelpCenter";
import ViewHelpCenter from './ViewHelpCenter';
import Chat from "./Chat";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<App />} />
        <Route path="login" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="register" element={<Register />} />
        <Route path="createpost" element={<PrivateRoute><CreatePost /></PrivateRoute>} />
        <Route path="statistics" element={<PrivateRoute><Statistics /></PrivateRoute>} />
        <Route path="gamification" element={<PrivateRoute><Gamification /></PrivateRoute>} />
        <Route path="profile" element={<PrivateRoute><ViewProfile /></PrivateRoute>} />
        <Route path="findfriends" element={<PrivateRoute><FindFriend /></PrivateRoute>} />
        <Route path="upcomingbday" element={<PrivateRoute><UpcomingBday /></PrivateRoute>} />
        <Route path="loginhistory" element={<PrivateRoute><LoginHistory /></PrivateRoute>} />
        <Route path="chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
        <Route path="ViewQueries" element={<PrivateRoute><ViewHelpCenter /></PrivateRoute>} />
        <Route path="HelpCenter" element={<HelpCenter />} />
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="TermsOfService" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);